export default __webpack_public_path__ + "static/media/logo_agap2IT.a93161b3.svg";